<template>

    <div class="message" @click="messageControlsActive = !messageControlsActive"
         v-bind:class="'message--' + message.authorType">
        <div class="message__meta">
            <span class="message__date">{{ message.timestampHumanReadable }}</span> &ndash; <span
                class="message__author">{{ this.author }}</span>
        </div>
        <div class="message__bubble" :class="{imageBubble : message.messageType === 'image'}">
            <div v-if="message.messageType !== 'image'" v-html="urlify(message.messageText)"></div>
            <div v-if="message.messageType === 'image'">
                <img :src="message.messageText" alt="Thumbnail" class="message__thumbnail" @click="openOverlay"
                     height="150">
                <div class="media-overlay" ref="openMe" @click="showOverlay = !showOverlay"
                     :class="{'media-overlay--active' : showOverlay}">
                    <div class="media-overlay__wrapper">
                        <i class="media-overlay__icon fa fa-close"></i>
                        <div class="media-overlay__content">
                            <img class="media-overlay__media" :src="message.messageText">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <i v-if="messageControlsActive && !isCampaignNotificationImage" @click="deleteMessage"
           class="media-overlay__icon__delete fa fa-trash" :class="message.authorType"></i>
    </div>

</template>
<script>
export default {
    name: 'Message',
    props: ['message', 'currentChat'],
    components: {},
    computed: {
        author: function () {
            switch (this.message.authorType) {
                case 'support':
                    return this.currentChat.fullEmployeeName;
                case 'customer':
                    return this.currentChat.fullCustomerName;
                default:
                    return 'System';
            }
        },
        isCampaignNotificationImage: function () {
            // Image from CampaignNotification doesnt contain token query parameter, see assambled URL in ChatService.php 180, but images uploaded
            // through app or backend do contain token.
            // TODO: add new characteristic to chat message to determine image was sent from Campaign
            return this.message.authorType === 'support' && this.message.messageType === 'image' && !this.message.messageText.includes('token=')
        }
    },
    data() {
        return {
            showOverlay: false,
            messageControlsActive: false,
        }
    },
    methods: {
        openOverlay: function () {
            this.$refs.openMe.click();
        },
        deleteMessage: function () {
            this.$store.getters.getFireStore.deleteMessage(this.currentChat.clientId, this.currentChat.customerId, this.message);
        },
        urlify(text) {
          let urlRegex = /(https?:\/\/[^\s]+)/g;
          if (urlRegex.test(text)) {
            return text.replace(urlRegex, function(url) {
              return '<a href="' + url + '" target="_blank">' + url + '</a>';
            })
          } else {
            return text;
          }
        }
    }
}
</script>
<style lang="scss">

$green: #86BB71;
$blue: #94C2ED;
$orange: #E38968;
$gray: #92959E;

.message {
  font-size: 12px;
  padding: 0;
  border: 0;
  margin-bottom: 20px;
  position: relative;
  white-space: pre-line;
  background: initial;

  &__thumbnail {
    max-width: 350px;
    max-height: 350px;
    width: 100%;
    height: auto;
    margin: 10px 0;
    border-radius: 7px;
  }

  &:first-of-type {
    margin-top: 25px;
  }

  &--service {
    text-align: center;
    justify-content: center;

    .message__bubble {
      color: $gray;
      border-radius: 0;
      position: relative;
      padding-left: 0;
      padding-right: 0;
      padding-top: 0;
      margin-top: 0;
      margin-left: auto;
      margin-right: auto;
    }
  }

  &--customer {
    .message__bubble {
      background: #ebebeb;
      box-shadow: 2px 2px 2px #dbdbdb;
      color: #000;

      &.imageBubble {
        padding: 5px;

        &::before, ::after {
          content: none;
        }

        .message__thumbnail {
          padding: 0;
          margin: 0;
        }
      }

      &::before {
        content: "";
        position: absolute;
        z-index: 0;
        bottom: 10px;
        left: -7px;
        height: 20px;
        width: 20px;
        background: #ebebeb;
        border-bottom-right-radius: 15px;
      }

      &::after {
        content: "";
        position: absolute;
        z-index: 1;
        bottom: 10px;
        left: -10px;
        width: 10px;
        height: 20px;
        background: #fff;
        border-bottom-right-radius: 10px;
      }
    }
  }

  &--support {
    text-align: right;

    .message__meta {
      text-align: right;
    }

    .message__bubble {
      background: #1E64FF;
      margin-left: auto;
      display: inline-block;
      box-shadow: 0 4px 2px -2px #1E64FF;
    }

    &::after {
      content: "";
      position: absolute;
      z-index: 1;
      bottom: 10px;
      right: -10px;
      width: 10px;
      height: 20px;
      background: white;
      border-bottom-left-radius: 10px;
    }

    &::before {
      content: "";
      position: absolute;
      z-index: 0;
      bottom: 10px;
      right: -8px;
      height: 20px;
      width: 20px;
      background: #1E64FF;
      background-attachment: fixed;
      border-bottom-left-radius: 15px;
    }
  }

  &__meta {
    font-size: 10px;
  }

  &__bubble {
    max-width: 80%;
    display: inline-block;
    margin-top: 5px;
    color: white;
    padding: 10px 20px;
    border-radius: 7px;
    overflow: hidden;
  }
}

.imageThumbnail {
  cursor: pointer;
}

.media-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999999;
  transition: all 0.5s;
  opacity: 0;
  pointer-events: none;

  &--active {
    opacity: 1;
    pointer-events: auto;

    .media-overlay {
      &__wrapper {
        transform: scale(1);
      }
    }
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: -1;
  }

  &__icon {
    position: absolute;
    top: 0;
    right: 0;
    width: 30px;
    height: 30px;
    background: #fff;
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(50%, -50%);
    color: #333;
    cursor: pointer;
  }

  &__icon__delete {
    position: absolute;
    top: 0;
    left: 0;
    width: 30px;
    height: 30px;
    background: #fff;
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.15);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translate(50%, -50%);
    color: #333;
    cursor: pointer;

    &.service {
      top: 0;
      left: 55%;
    }

    &.customer {
      top: 25%;
      left: -5%
    }

    &.support {
      top: 25%;
      left: 95%;
    }
  }

  &__wrapper {
    transition: all 0.4s;
    background: #fff;
    position: relative;
    padding: 30px;
    transform: scale(0.9);
  }

  &__content {
    max-width: 90vw;
    max-height: 90vh;
  }

  &__media {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: relative;
    max-width: 90vw;
    max-height: 90vh;
  }
}
</style>
